import { defineField } from '../fieldBuilder';

import type { RequestFieldDefinition } from '../types';

/** rack-power — registry field list (generated from legacy SummarySpecs; edit here going forward). */
export const RACK_POWER_FIELDS: readonly RequestFieldDefinition[] = [
  defineField(
    'rack-power',
    'rackInformation',
    0,
    'locationTagId',
    'Location',
    'Location',
  ),
  defineField(
    'rack-power',
    'rackInformation',
    1,
    'rackPlatform',
    'Rack platform',
    'Platform',
  ),
  defineField(
    'rack-power',
    'rackInformation',
    2,
    'rackDescription',
    'Description',
    'Description',
  ),
  defineField('rack-power', 'rackInformation', 3, 'rackUse', 'Rack use', 'Use'),
  defineField(
    'rack-power',
    'rackInformation',
    4,
    'rackQuantity',
    'Rack quantity',
    'Quantity',
  ),
  defineField(
    'rack-power',
    'rackInformation',
    5,
    'rackRequiresLiquidToChip',
    'Do racks require liquid-to-chip cooling?',
    'Liquid-to-chip',
  ),
  defineField(
    'rack-power',
    'rackInformation',
    6,
    'rackDescribeElevations',
    'Describe rack elevations',
    'Elevations',
  ),
  defineField(
    'rack-power',
    'specs',
    0,
    'rackSeismicRated',
    'Seismic rated?',
    'Seismic',
  ),
  defineField(
    'rack-power',
    'specs',
    1,
    'rackMaxLoadRating',
    'Max load rating',
    'Max load',
  ),
  defineField('rack-power', 'specs', 2, 'rackColor', 'Color', 'Color'),
  defineField(
    'rack-power',
    'specs',
    3,
    'rackDimensionsHeight',
    'Height [RU/OU]',
    'Height',
  ),
  defineField(
    'rack-power',
    'specs',
    4,
    'rackDimensionsLength',
    'Depth',
    'Depth',
  ),
  defineField(
    'rack-power',
    'specs',
    5,
    'rackDimensionsWidth',
    'Width',
    'Width',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    0,
    'rackPduManufacturer',
    'Manufacturer',
    'Manufacturer',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    1,
    'rackPduModel',
    'Model',
    'Model',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    2,
    'rackPduMaxKwPerRack',
    'Max kW per rack',
    'Max kW per rack',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    3,
    'powerAverageItLoadPerRackKw',
    'Average IT Load per rack [kW]',
    'Average IT Load per…',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    4,
    'powerMaximumItLoadPerRackKw',
    'Maximum IT load per rack [kW]',
    'Maximum IT load per…',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    5,
    'powerNumberAndTypeInputPerRack',
    'Number and type of PDUs',
    'Number and type of …',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    6,
    'rackPduPowerType',
    'AC or DC power (rPDUs or Power Shelves or both)',
    'AC or DC power (rPD…',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    7,
    'rackPduInputPlugType',
    'Input plug type',
    'Input plug type',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    8,
    'rackPduCountPerRack',
    'How many rPDU per rack?',
    'How many rPDU per r…',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    9,
    'rackPduDcPowerShelves',
    'How many DC power shelves?',
    'How many DC power s…',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    10,
    'rackPduOutletSwitchingMonitored',
    'Unit Monitored, Outlet Switching or Outlet Monitored?',
    'Unit Monitored, Out…',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    11,
    'rackPduCapacityAmps',
    'Amp capacity',
    'Amp capacity',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    12,
    'rackPduCapacityVolts',
    'Voltage',
    'Voltage',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    13,
    'rackPduCapacityKw',
    'kW capacity',
    'kW capacity',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    14,
    'rackPduLoadReadingsKw',
    'Load readings',
    'Load readings',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    15,
    'rackPduMountingType',
    'Mounting Type (Horizontal/Vertical)',
    'Mounting Type (Hori…',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    16,
    'rackPduOutletTypesQuantity',
    'How many of each outlet type?',
    'How many of each ou…',
  ),
  defineField(
    'rack-power',
    'rackElectrical',
    17,
    'rackPduLocation',
    'Location in Rack',
    'Location in Rack',
  ),
  defineField(
    'rack-power',
    'additionalInformation',
    0,
    'rackAdditionalRackInformation',
    'Additional Rack Configuration Information',
    'Additional',
  ),
];
